import { useNavigate } from "@tanstack/react-router";

import { trackAlertsPageViewed } from "@/config/mixpanel";
import { documentationRoute } from "@/pages/Documentation/route";
import { homeRoute } from "@/pages/Home/route";
import { loginRoute } from "@/pages/Login/route";
import { plantsRoute } from "@/pages/Plants/route";
import { useAuth } from "@/providers/auth";

// El targeting de la encuesta VoC en Contentsquare se dispara cuando la URL
// contiene este query param. Debe coincidir con la regla configurada en el panel.
const feedbackSurveyParam = "open_feedback_survey";

export const useSidebarNavigation = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleHomeClick = () => {
    void navigate({ to: homeRoute.to });
  };

  const handlePlantsClick = () => {
    void navigate({ to: plantsRoute.to });
  };

  const handleDocumentationClick = () => {
    void navigate({ to: documentationRoute.to });
  };

  const handleAlertsClick = () => {
    trackAlertsPageViewed("sidebar");
    void navigate({ to: "/alerts" });
  };

  const handleLogoutClick = () => {
    logout();
    void navigate({ to: loginRoute.to });
  };

  const handleFeedbackClick = () => {
    // Pageview virtual: señala a Contentsquare una URL con el param de feedback
    // para disparar la encuesta, sin alterar la URL real del navegador.
    window._uxa = window._uxa || [];
    const sep = window.location.search ? "&" : "?";
    window._uxa.push([
      "setPath",
      `${window.location.pathname}${window.location.search}${sep}${feedbackSurveyParam}=true`,
    ]);
    window._uxa.push(["trackPageview"]);
  };

  return {
    onPlantsClick: handlePlantsClick,
    onDocumentationClick: handleDocumentationClick,
    onAlertsClick: handleAlertsClick,
    onHomeClick: handleHomeClick,
    onLogoutClick: handleLogoutClick,
    onFeedbackClick: handleFeedbackClick,
  };
};
